// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file settings/v1/app_status.proto (package settings.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file settings/v1/app_status.proto.
 */
export const file_settings_v1_app_status: GenFile =
    /*@__PURE__*/
    fileDesc(
        'ChxzZXR0aW5ncy92MS9hcHBfc3RhdHVzLnByb3RvEgtzZXR0aW5ncy52MSpYCglBcHBTdGF0dXMSGwoXQVBQX1NUQVRVU19VTlNDUEVDSUZJRUQQABIVChFBUFBfU1RBVFVTX0FDVElWRRABEhcKE0FQUF9TVEFUVVNfSU5BQ1RJVkUQAkJ0Cg9jb20uc2V0dGluZ3MudjFCDkFwcFN0YXR1c1Byb3RvUAFaBC4vcGKiAgNTWFiqAgtTZXR0aW5ncy5WMcoCC1NldHRpbmdzXFYx4gIXU2V0dGluZ3NcVjFcR1BCTWV0YWRhdGHqAgxTZXR0aW5nczo6VjFiBnByb3RvMw'
    );

/**
 * @generated from enum settings.v1.AppStatus
 */
export enum AppStatus {
    /**
     * @generated from enum value: APP_STATUS_UNSCPECIFIED = 0;
     */
    UNSCPECIFIED = 0,

    /**
     * @generated from enum value: APP_STATUS_ACTIVE = 1;
     */
    ACTIVE = 1,

    /**
     * @generated from enum value: APP_STATUS_INACTIVE = 2;
     */
    INACTIVE = 2,
}

/**
 * Describes the enum settings.v1.AppStatus.
 */
export const AppStatusSchema: GenEnum<AppStatus> = /*@__PURE__*/ enumDesc(file_settings_v1_app_status, 0);
